import { render, staticRenderFns } from "./side.vue?vue&type=template&id=2c958c1e"
import script from "./side.vue?vue&type=script&lang=js"
export * from "./side.vue?vue&type=script&lang=js"
import style0 from "./side.vue?vue&type=style&index=0&id=2c958c1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports